import React from 'react';

function Hyperlinks({ data, onClick }) {
  let desc = data.split('\n');
  let extractedesc = desc.flatMap((line) => line.split(' '));
  const isURL = (word) => {
    const urlRegex = /^(?:\w+:)?\/\/([^\s.]+\.\S{2}|localhost[:?\d]*)\S*$/;
    return urlRegex.test(word);
  };

  const CheckUrl = () => {
    return extractedesc.map((word, index) => {
      if (isURL(word)) {
        return (
          <React.Fragment key={index + word}>
            <a href={word} target="_blank" rel="noopener noreferrer">
              {word}{' '}
            </a>{' '}
          </React.Fragment>
        );
      }
      return <span key={index + word}>{word} </span>;
    });
  };

  const clickAction = () => {
    onClick();
  };

  return (
    <p onClick={clickAction}>
      <CheckUrl />
    </p>
  );
}

export default Hyperlinks;
